document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  if (!header) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});

/* -------------------------
  Collection page
------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector(
    "#shopify-section-template--19681174978793__rich_text_YaiJeF .isolate .rich-text .rich-text__wrapper .rich-text__blocks h2"
  );

  if (target) {
    const newH1 = document.createElement("h1");
    newH1.innerHTML = target.innerHTML;
    newH1.style.fontSize = "52px"; // set font-size
    target.replaceWith(newH1);
  }
});
/* -------------------------
/* -------------------------
  Light Box
------------------------- */

document.addEventListener('DOMContentLoaded', function() {
  
  const lightbox = document.getElementById('lightbox');
  if (!lightbox) return; // stop if lightbox div is missing

  const lightboxImg = lightbox.querySelector('img');
  const closeBtn = lightbox.querySelector('.lightbox-close');
  const nextBtn = lightbox.querySelector('.lightbox-next');
  const prevBtn = lightbox.querySelector('.lightbox-prev');

  // Simplified selector targeting only your two pages
 const images = document.querySelectorAll(
  '#shopify-section-template--19681174946025__multicolumn_9Jm4fL img, ' +
  '#shopify-section-template--20017656103145__multicolumn_Li6NL9 img, ' +
  '#shopify-section-template--20024173101289__multicolumn_KTefpx img'
);

  if (images.length === 0) return; // no images found

  let currentIndex = 0;

  // Open lightbox
  images.forEach((img, index) => {
    img.addEventListener('click', () => {
      currentIndex = index;
      lightboxImg.src = img.src;
      lightbox.style.display = 'flex';
    });
  });

  // Close lightbox
  closeBtn.addEventListener('click', () => {
    lightbox.style.display = 'none';
  });

  // Next image
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % images.length;
    lightboxImg.src = images[currentIndex].src;
  });

  // Previous image
  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    lightboxImg.src = images[currentIndex].src;
  });

  // Close when clicking outside image
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
    }
  });

});






